export default function () {

  const originalWarning = $('#isi-top'),
    stickyWarning = $('.isi-container.fixed').not('.placeholder'),
    stickyWarningPlaceholder = $('.isi-container.fixed.placeholder'),
    stickyButton = stickyWarning.find('.isi-button'),
    stickyContent = stickyWarning.find('.isi-content');

  // Local Scope:
  function toggleSticky(expandedStatus) {
    var buttonText = stickyButton.find('.text');

    if (expandedStatus) { // it is expanded, collapse it
      stickyWarning.removeClass('enlarged');
      buttonText.html('Show More');
    } else { // it is NOT expanded, open it
      stickyWarning.addClass('enlarged');
      buttonText.html('Show Less');
    }

    // toggle the expanded status, after performing the action
    stickyWarning.data('enlarged', !expandedStatus);

    // regardless of where it was, scroll it to the top afterwards
    stickyContent.scrollTop(0);
  }

  function getStickyOffset() {
    if (stickyWarningPlaceholder.offset())
      return stickyWarningPlaceholder.offset().top;
  }

  function getStickyOffset_Apple8() {
    return window.getScrollY() + (window.isApplePad() ? 290 : 68) +
    ($(window).outerHeight(true) - stickyWarningPlaceholder.outerHeight(true));
  }

  function getOriginalWarningOffset() {
    if (originalWarning.offset())
      return originalWarning.offset().top;
  }

  // Global Scope:
  window.checkStickyWarning = function () {
    const offset = window.isApple8() ? getStickyOffset_Apple8() : getStickyOffset();
    const orgWarnOffset = getOriginalWarningOffset();

    if (offset >= orgWarnOffset) {
      // hide the sticky
      stickyWarning.addClass('collapsed');

      // if it's expanded, shrink it
      if (stickyWarning.data('enlarged')) {
        toggleSticky(true);
      }
    } else {
      // reveal the sticky
      stickyWarning.removeClass('collapsed');
    }
  };

  // determines whether the device is iOS 8+ or not
  window.isApple8 = function () {
    return (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) ? (!window.indexedDB) : false;
  };

  // determines whether the device is an iPad or not
  window.isApplePad = function () {
    return (/(iPad)/g.test(navigator.userAgent));
  };

  // returns the current vertical scroll position
  window.getScrollY = function () {
    return (window.pageYOffset !== null) ? window.pageYOffset : (document.documentElement.scrollTop !== null) ? document.documentElement.scrollTop : document.body.scrollTop;
  };

  // Page Load:
  stickyWarning.data('enlarged', false);

  stickyButton.on('click', function () {
    toggleSticky(stickyWarning.data('enlarged'));
  });

  // making sure content has enough time to load
  setTimeout(function () {
    window.checkStickyWarning();
  }, 100);

  $(window).on('scroll', function () {
    window.checkStickyWarning();
  });

  $(window).on('resize', function () {
    window.checkStickyWarning();
  });

  // Accordion Collapse Events
  $('.panel-group').on('shown.bs.collapse', function () {
    window.checkStickyWarning();
  });
  $('.panel-group').on('hidden.bs.collapse', function () {
    window.checkStickyWarning();
  });

}


// WEBPACK FOOTER //
// ./js/modules/sticky-drawer.js